import './setupAssets.js';
/* css */
import './css/redbook-v2.css';
import './css/redbook-custom-v2.css';

import Vue from 'vue';
import VueRouter from 'vue-router';
import App from '@/components/App.vue';
import store from '@/store';
import routes from '@/routes';
import { legacyReadHashRedirect } from '@/utils/legacyReadHash';

import { FETCH_BUILDINGS, FETCH_PROBLEMS, FETCH_SESSION } from '@/store/actions.type';

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

router.beforeEach((to, from, next) => {
  const redirect = legacyReadHashRedirect(to);
  if (redirect) {
    next({ ...redirect, replace: true });
    return;
  }
  next();
});

const fetchProblems = () => store.dispatch(FETCH_PROBLEMS);
const fetchBuildings = () => store.dispatch(FETCH_BUILDINGS);
const fetchSession = () => store.dispatch(FETCH_SESSION);

export async function init() {
  const rootEl = document.getElementById('app');
  if (!rootEl) {
    console.error('[redbook] Missing #app root element');
    return;
  }

  await fetchSession();
  await Promise.all([fetchProblems(), fetchBuildings()]);

  new Vue({
    el: rootEl,
    template: '<App/>',
    components: { App },
    store,
    router,
  });
}

init();
